import { render } from "./SuccessCreate.vue?vue&type=template&id=5ab753f2"
import script from "./SuccessCreate.vue?vue&type=script&lang=js"
export * from "./SuccessCreate.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__